import { Separator } from "@components/common/separator";
import useTranslator from "@hooks/use-translator";
import { HOME_PAGE_ROUTE, DASHBOARD_PAGE_ROUTE } from "@pma/utils/page-routes";
import { ChevronRight } from "lucide-react";
import { ChevronLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router";

import { Link } from "react-router-dom";
import { usePageContext } from "@pma/stores/page-context-store";

const Breadcrumbs = () => {
  const pathname: string = useLocation().pathname;
  const navigate = useNavigate();

  const { translate, locale } = useTranslator();
  const { breadcrumbOverrides } = usePageContext();

  const isHebrew = locale === "he";

  // Split the pathname into its segments and create an array of breadcrumb items
  const crumbs = pathname
    .replace(HOME_PAGE_ROUTE, "")
    .split("/")
    .slice(2)
    .filter((segment) => segment !== "")
    .map((segment, index, segments) => {
      const path = `/${segments.slice(0, index + 1).join("/")}`;
      return { name: segment, path };
    });

  const Icon = isHebrew ? (
    <ChevronLeft size="18" />
  ) : (
    <ChevronRight size="18" />
  );
  return (
    <div className="flex items-center p-1 text-xs">
      <button
        className="flex h-6 w-6 items-center rounded-md bg-opacity-80 hover:bg-primary hover:bg-opacity-40 hover:text-primary-foreground"
        onClick={() => navigate(-1)}
        title={"Back"}
      >
        {isHebrew ? <ChevronRight size="20" /> : <ChevronLeft size="" />}
      </button>
      <Separator orientation="vertical" className="mx-2 h-5" />
      <Link to={DASHBOARD_PAGE_ROUTE} className="flex  items-center ">
        <span>{translate("Home")}</span>{" "}
      </Link>
      {crumbs.map((crumb, index) => (
        <div
          className={`mx-1 flex items-center ${
            crumbs.length - 1 > index ? "" : "text-foreground text-opacity-50"
          }`}
          key={crumb.path}
        >
          {crumbs.length - 1 > index ? (
            <Link
              to={DASHBOARD_PAGE_ROUTE + crumb.path}
              className={"flex items-center capitalize"}
            >
              {isHebrew ? (
                <ChevronLeft size="18" />
              ) : (
                <ChevronRight size="18" />
              )}
              <span
                className={
                  "flex w-fit max-w-[25ch] items-center truncate text-ellipsis capitalize"
                }
              >
                {breadcrumbOverrides[crumb.name] || translate(crumb.name.replace("_", " "))}
              </span>
            </Link>
          ) : (
            <>
              {Icon}

              <div
                className={"flex w-fit max-w-[25ch] font-semibold capitalize"}
              >
                <span className="truncate text-ellipsis">
                  {breadcrumbOverrides[crumb.name] || translate(crumb.name.replace("_", " "))}
                </span>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
